import { PATH_NAME } from "../configs/pathName";
import axiosInstance from "./axiosInstance";

export const getSkus = async () => {
  const response = await axiosInstance.get(PATH_NAME.API_GET_SKU_DETAILS);
  return response.data.result.items;
};

export const getSkuBySku = async (sku: string) => {
  const response = await axiosInstance.get(PATH_NAME.API_GET_SKU_DETAILS_BY_SKU(sku));
  return response.data.result.items;
};
